import { render } from "./TaskView.vue?vue&type=template&id=cb2fbd4e&scoped=true&ts=true"
import script from "./TaskView.vue?vue&type=script&lang=ts"
export * from "./TaskView.vue?vue&type=script&lang=ts"

import "./TaskView.vue?vue&type=style&index=0&id=cb2fbd4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2fbd4e"]])

export default __exports__